<script type="text/javascript">

	import {get, writable} from "svelte/store";
	import OAuthStore from "../../OAuth/Store";
	import AuthState from "../../Auth/Enums/AuthState";
	import ESRIClassStore from "../../Stores/ESRIClassStore";

	// TODO: consider refactoring to be generic oauth require
	// e.g. <RequireOAuth configKey="agol" on:valid={} on:invalid={} name="ArcGIS Online"/>

	let currentAccessToken = writable("");
	let authState = OAuthStore.configs.agol.authState;
	let accessToken = OAuthStore.configs.agol.token.access;
	$: {
		$authState;
		if ($authState === AuthState.LOGGED_IN) {
			$currentAccessToken = $accessToken;
		}
		else if ($authState === AuthState.LOGGED_OUT) {
			$currentAccessToken = "";
		}
	}

	currentAccessToken.subscribe((token)=>{
		if (token.length > 0) {
			ESRIClassStore.actions.load().then(()=>{
				console.log("IdentityManager: registering token", token);
				const IdentityManager = ESRIClassStore.classes.IdentityManager.classPrototype;
				IdentityManager.registerToken({
					token: token,
					server: "https://www.arcgis.com/sharing/rest"
				});
			});
		}
		else {
			// // unregister token?
			// ESRIClassStore.actions.load().then(()=>{
			// 	console.log("IdentityManager: destroying all tokens");
			// 	const IdentityManager = ESRIClassStore.classes.IdentityManager.classPrototype;
			// 	IdentityManager.destroyCredentials();
			// });
		}
	});

</script>

{#if $authState === AuthState.LOGGED_OUT}
	<h1>ArcGIS Online Required</h1>
	<p>Please <a href={OAuthStore.configs.agol.redirectUrl}>click here</a> to authenticate.</p>
{:else if $authState === AuthState.LOGGED_IN}
	<slot/>
{/if}
